/* istanbul ignore file */
import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

const headingFont = css`
  ${responsiveText.HEADING.XS};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

const headingSpacing = css`
  margin-top: 0;
  margin-bottom: ${spacing.xs}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-bottom: ${spacing.sm}px;
    `,
  )};
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin-bottom: ${spacing.md}px;
    `,
  )};
`;

export const copyContainer = css`
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  th,
  th > p {
    ${headingFont}
  }

  td,
  th {
    border: 1px solid var(--neutral-black-10);
    padding: 5px;

    ${mediaQuery(
      { max: maxBreakpoints.M },
      css`
        display: block;
      `,
    )};
  }

  tr td:first-child,
  tr td:first-child > p {
    ${mediaQuery(
      { max: maxBreakpoints.M },
      css`
        ${headingFont}
      `,
    )};
  }

  h1 {
    ${responsiveText.HEADING.XL};
    ${headingSpacing};
  }

  h2 {
    ${responsiveText.HEADING.LG};
    ${headingSpacing};
  }

  h3 {
    ${responsiveText.HEADING.MD};
    ${headingSpacing};
  }

  h4 {
    ${responsiveText.HEADING.SM};
    ${headingSpacing};
  }

  h5 {
    ${responsiveText.HEADING.XS};
    ${headingSpacing};
  }

  p,
  li {
    ${responsiveText.BODY.MD};
  }

  p {
    margin-top: 0;
    margin-bottom: ${spacing.md}px;

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        margin-bottom: ${spacing.lg}px;
      `,
    )};
    ${mediaQuery(
      { min: minBreakpoints.L },
      css`
        margin-bottom: ${spacing.xl}px;
      `,
    )};
  }
`;
